import request from '@/utils/request'
const apiPath = '/education/educationCompany'
import qs from 'qs'
const educationCompanyApi = {
  /**
   * 新增【教育公司】
   */
  create(data) {
    return request.post(`${apiPath}`, data)
  },
  /**
   * 修改【教育公司】
   */
  update(data) {
    return request.put(`${apiPath}`, data)
  },
  /**
   * 分页查询【教育公司佣金分页列表】
   */
  fetchList(query) {
    return request.get(`${apiPath}/findEducationCommissionListByPage`, { params: query })
  },
  getEducationComList(query) {
    return request.get(`${apiPath}/getCourseOrderEducationCommissionList`, { params: query })
  },
  /**
   * 查看【教育公司】详情
   */
  fetchById() {
    return request.get(`${apiPath}/searchEducationCompany`)
  },
  // 导出
  findEducationExport(query) {
    return request.post(`${apiPath}/findEducationExport`,query)
  },
  educationCourserOrMeetingExport(query) {
    return request.post(`${apiPath}/educationCourserOrMeetingExport`,query)
  }
}
export default educationCompanyApi
